module.exports = __webpack_public_path__ + "img/icon-white-48.b529d9fa.svg";